<script>
import { nameBubbleColors } from '../utils/config';
export default {
    props: {
        Words: {
            type: Object,
            required: true,
        },

        XonHover: {
            type: Boolean,
            required: true,
        },

        Count: {
            type: Number,
            required: true,
        },

        Radius: {
            type: Number,
            default: 26,
        },

        PutEmphasis: {
            type: Boolean,
            default: null,
        },
    },

    data() {
        return {
            hovered: false,
        }
    },

    computed: {
        text() {
            let _text = '';
            
            if (this.Count == null) {
                for (let i = 0; i < this.Words.length; i++) {
                    _text = _text + this.Words[i][0].toUpperCase();
                }
            } else {
                return `+${this.Count}`;
            }

            return _text;
        },

        bgColor() {
            const first_word = this.Words[0] || 'ab';
            const second_word = this.Words[1] || 'ab';
            
            const code = first_word.charCodeAt(0) + second_word.charCodeAt(0);
            const index = code % nameBubbleColors.length;
            return nameBubbleColors[index];
        },
    },

    mounted() {

    },

    methods: {
        handleHover(bool) {
            if (this.XonHover)
                this.hovered = bool;
        },

        clickBubble() {
            this.$emit('clickBubble');
        },
    }
}
</script>

<template>
    <div class="name-bubble" 
        :style="{ 
            color: 'white', 
            backgroundColor: hovered ? 'rgba(210, 82, 31, .9)' : bgColor ,
            'min-width': `${Radius}px`,
            'max-width': `${Radius}px`,
            'min-height': `${Radius}px`,
            'max-height': `${Radius}px`,
        }"
        :class="{
            'no-brightness': hovered === true,
            'put-emphasis': PutEmphasis === true,
            'no-put-emphasis': PutEmphasis === false,
        }"
        @mouseover="() => handleHover(true)"
        @mouseleave="() => handleHover(false)"
        @click="clickBubble()"
    >
        <div v-if="!hovered">
            {{ text }}
        </div>
        <div v-else>
            <i class="fa-solid fa-xmark"></i>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.name-bubble {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 1000px;
    outline: thin solid whitesmoke;
    container-type: size;
    overflow: hidden;

    cursor: pointer;
    transition: filter 250ms;
    &:hover {
        filter: brightness(1.25);
        z-index: 999;
    }

    > div {
        font-size: 30cqw !important;
        width: 100% !important;
        height: 100% !important;
        padding: .5em !important;
    }
}

.no-brightness {
    filter: none !important;
}

.put-emphasis {
    z-index: 999;
    opacity: 1;
}
.no-put-emphasis {
    background-color: darkgray !important;
    opacity: 0.9;
}
</style>